$(document).on('turbolinks:load', function () {
  $('body').on('mousedown', '.js-link', function () {
    $(this).attr('href', $(this).data('url')).removeClass('js-link');
  });
});
